<div class="action-bar">
  <a class="back-button" (click)="cancel()"><i class="chevron left icon"></i></a>
  <div class="title-text">
    编辑对 <span class="bangumi-name">{{item.name}}</span> 的评价
  </div>
</div>
<div class="edit-review-container">
  @if (item.coverImage) {
    <div class="bangumi-info">
      <ui-responsive-image [src]="item.coverImage.url"
                          [size]="{
                                width: '100%',
                                height: 'auto',
                                originalWidth: item.coverImage.width,
                                originalHeight: item.coverImage.height}"
      [background]="item.coverImage.dormantColor"></ui-responsive-image>
      @if (item.nameCn) {
        <div class="bangumi-name-cn">{{item.nameCn}}</div>
      }
    </div>
  }
  <form class="ui form" [formGroup]="reviewForm" (submit)="onSubmit($event)" [ngClass]="{inverted: isDarkTheme}">
    <div class="field">
      <div class="small ui buttons" [ngClass]="{inverted: isDarkTheme, basic: !isDarkTheme}">
        <button class="ui button" [ngClass]="{active: favorite_status === eFavoriteStatus.Planned, inverted: isDarkTheme}" (click)="chooseFavoriteStatus(eFavoriteStatus.Planned)">
          想看
        </button>
        <button class="ui button" [ngClass]="{active: favorite_status === eFavoriteStatus.Watched, inverted: isDarkTheme}" (click)="chooseFavoriteStatus(eFavoriteStatus.Watched)">
          看过
        </button>
        <button class="ui button" [ngClass]="{active: favorite_status === eFavoriteStatus.Watching, inverted: isDarkTheme}" (click)="chooseFavoriteStatus(eFavoriteStatus.Watching)">
          在看
        </button>
        <button class="ui button" [ngClass]="{active: favorite_status === eFavoriteStatus.OnHold, inverted: isDarkTheme}" (click)="chooseFavoriteStatus(eFavoriteStatus.OnHold)">
          搁置
        </button>
        <button class="ui button" [ngClass]="{active: favorite_status === eFavoriteStatus.Dropped, inverted: isDarkTheme}" (click)="chooseFavoriteStatus(eFavoriteStatus.Dropped)">
          抛弃
        </button>
      </div>
    </div>
    <div class="field">
      <textarea name="comment" cols="20" rows="10"
        formControlName="comment"
      placeholder="对新番的吐槽，最多200字"></textarea>
    </div>
    <div class="field">
      <div class="word-left" [ngClass]="{warning: reviewForm.controls['comment'].invalid}">{{reviewForm.controls['comment'].value.length}}/200</div>
    </div>
    <div class="field">
      <div class="ui huge star rating" (mouseleave)="onHoverRating(0)">
        @for (s of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track s) {
          <i class="icon"
            [ngClass]="{active: (s <= rating && !isHovering) || (s <= hoverScore && isHovering), selected: s <= hoverScore}"
            (mouseover)="onHoverRating(s)"
          (click)="onSelectRating(s)"></i>
        }
      </div>
      <div class="rating-text">
        {{isHovering ? hoveringText: ratingText}}
        @if (!!hoverScore || !!rating) {
          <span class="score">{{isHovering ? hoverScore : rating}}</span>
        }
        @if (isHovering && hoverScore === 10) {
          <span class="warning-tip">(请谨慎评价)</span>
        }
      </div>
    </div>
    <div class="footer">
      <button class="ui button" [ngClass]="{inverted: isDarkTheme}" type="button" (click)="cancel()">取消</button>
      <button class="ui primary button" [ngClass]="{inverted: isDarkTheme}" type="button" (click)="save()" [disabled]="reviewForm.invalid || !favorite_status">提交</button>
    </div>
  </form>
</div>
